module.exports = __webpack_public_path__ + "img/shipyard.3b20f3ab.png";